import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './styles.scss';
import typography from '../../src/Typography';

var EndorseContentLayout = function EndorseContentLayout(_ref) {
  var head = _ref.head,
      content = _ref.content,
      primaryCta = _ref.primaryCta,
      secondaryCta = _ref.secondaryCta;
  return React.createElement(
    'div',
    { className: styles.root },
    head && React.createElement(
      'div',
      { className: classnames(styles.head, typography.h1) },
      head
    ),
    content && React.createElement(
      'div',
      { className: classnames(styles.content, typography.t1) },
      content
    ),
    primaryCta && React.createElement(
      'div',
      { className: styles.primaryCta },
      primaryCta
    ),
    secondaryCta && React.createElement(
      'div',
      { className: styles.secondaryCta },
      secondaryCta
    )
  );
};

EndorseContentLayout.propTypes = {
  head: PropTypes.node,
  content: PropTypes.node,
  primaryCta: PropTypes.node,
  secondaryCta: PropTypes.node
};

export default EndorseContentLayout;
//# sourceMappingURL=EndorseContentLayout.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/EndorseContentLayout/EndorseContentLayout.js